import React from 'react';

import { IconProps, StyledSvg } from '../iconCommons';

export const IconCalendar = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 17"
        strokeWidth="1.5"
        stroke={color}
        fill="none"
        size={size}
        {...props}
    >
        <rect x="1" y="2.5" width="13.5" height="13.5" rx="1.5" />
        <path d="M10.75 1v3m-6-3v3M1 7h13.5" strokeLinecap="round" />
    </StyledSvg>
);
